// extracted by mini-css-extract-plugin
export default {"root":"LEGCbM","bg":"kxMUb7"};